import React from 'react';

import ReactDOM from 'react-dom/client';

import './index.css';

import App from './App';

import reportWebVitals from './reportWebVitals';

import {
  AuthProvider
} from './context/AuthContext';

const root =
  ReactDOM.createRoot(
    document.getElementById('root')
  );

root.render(

  <AuthProvider>

    <App />

  </AuthProvider>

);

// PERFORMANCE
reportWebVitals();
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(() => {
        console.log('MACCEZ TRACK PWA activa');
      })
      .catch((error) => {
        console.error('Error registrando PWA:', error);
      });
  });
}
